import { RadialBarChart as ReRadialBarChart, RadialBar, Legend } from "recharts";
import { useSelector } from "react-redux";

export const RadialBarChart = () => {
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);
  const data = [
    {
      name: `A ${currencySymbol}0`,
      value: 510000,
      fill: "#349E88",
    },
    {
      name: `B ${currencySymbol}0`,
      value: 870000,
      fill: "#A2F8A9",
    },
    {
      name: `C ${currencySymbol}0`,
      value: 168000,
      fill: "#4EE3C5",
    },
  ];

  return (
    <ReRadialBarChart
      startAngle={90}
      endAngle={-180}
      width={230}
      height={230}
      innerRadius={75}
      outerRadius={125}
      data={data}
      style={{
        margin: "0 auto",
      }}
    >
      <RadialBar dataKey="value" clockWise />
      <Legend
        iconSize={0}
        layout="vertical"
        verticalAlign="middle"
        wrapperStyle={{
          top: 0,
          left: 20,
        }}
      />
    </ReRadialBarChart>
  );
};
